export default __webpack_public_path__ + "static/media/tsa.159470da.png";